import React, { useEffect } from 'react';
import { Button, Empty, Popup } from 'antd-mobile';
import outStyles from '../../index.module.scss';
import styles from './index.module.scss';
import { CloseCircleFill } from 'antd-mobile-icons';
import { useCallback, useState, useImperativeHandle, forwardRef } from 'react';
import AddTime from '../AddTime';
import NoData from '@/assets/images/noData.png';
import { formatTimeRangesWithTomorrow, transformTimeRangesWithTomorrow } from '../../util';
import { TimeDetailItem } from '@/api/energy';
import { isEmpty } from 'lodash-es';
import { ConfigArea } from '../..';

export interface ConfigurationTimeProp {
  footer?: React.ReactNode;
  configArea?: ConfigArea | null;
  disabledTimes?: Array<any>;
  onCancel?: () => void;
  onOk?: (params: TimeDetailItem[]) => void;
}

const ConfigurationTime = forwardRef<any, ConfigurationTimeProp>(
  ({ footer, onCancel, onOk, configArea, disabledTimes }, ref) => {
    const { detailList, date } = configArea || {};
    const [showAddDatePopup, setShowAddDatePopup] = useState(false);
    const [timeRangeList, setTimeRangeList] = useState<Array<{ startDateTime: string; endDateTime: string }> | null>(
      null
    );

    // 暴露给父组件的方法
    useImperativeHandle(
      ref,
      () => ({
        getTimeRangeList: () => timeRangeList ?? [],
      }),
      [timeRangeList]
    );
    useEffect(() => {
      if (detailList) {
        setTimeRangeList(transformTimeRangesWithTomorrow(date!, detailList));
      }
    }, [detailList]);

    const addTimeRangeList = useCallback(
      (startTime: Array<string | null>, endTime: Array<string | null>) => {
        setTimeRangeList([
          ...(timeRangeList ?? []),
          { startDateTime: startTime.join(''), endDateTime: endTime.join('') },
        ]);
      },
      [timeRangeList]
    );

    const handleConfirm = () => {
      const selectedTimeRanges = formatTimeRangesWithTomorrow(date!, timeRangeList ?? []);
      onOk!(selectedTimeRanges);
    };

    return (
      <>
        <div className={styles.container}>
          <div className={outStyles.popupTitleContainer}>
            <div className={outStyles.linkBtn}></div>
            <div className={outStyles.popupTitle}>配置时间</div>
            <div className={outStyles.linkBtn} onClick={() => setShowAddDatePopup(true)}>
              新增
            </div>
          </div>
          <div className={outStyles.popupContent}>
            {!isEmpty(timeRangeList) ? (
              timeRangeList!.map((item, index) => (
                <div className={outStyles.popupItem} key={index}>
                  {item.startDateTime}-{item.endDateTime}{' '}
                  <CloseCircleFill
                    color="#999999"
                    fontSize={18}
                    style={{ float: 'right' }}
                    onClick={() => {
                      setTimeRangeList(timeRangeList!.filter((_, i) => i !== index));
                    }}
                  />
                </div>
              ))
            ) : (
              <div className={outStyles.emptyState}>
                <Empty image={NoData} description="暂无数据" />
              </div>
            )}
          </div>
          {footer || (
            <div className={outStyles.actionBar}>
              <Button size="large" onClick={onCancel}>
                取消
              </Button>
              <Button size="large" color="primary" fill="solid" onClick={handleConfirm}>
                提交
              </Button>
            </div>
          )}
        </div>
        {showAddDatePopup && (
          <Popup visible={showAddDatePopup} position="bottom" className={outStyles.actionMenu}>
            <AddTime
              selectedTimeRange={timeRangeList?.map(timeRange => `${timeRange.startDateTime}-${timeRange.endDateTime}`)}
              onConfirm={addTimeRangeList}
              disabledTimes={disabledTimes}
              date={date}
              onCancel={() => setShowAddDatePopup(false)}
            />
          </Popup>
        )}
      </>
    );
  }
);

export default ConfigurationTime;
